import React from 'react';

const Logo = (props) => {
  return (
    <img
      alt="Logo"
      src="/static/companylogo.png"
      {...props}
    />
  );
};

export default Logo;
